import React from "react";
import { Spin } from "antd";
import { useAppContext } from "../../contexts/appContext";

const Spinner = () => {
  const { isLoading } = useAppContext();

  return (
    isLoading && (
      <div className="spinner-overlay">
        <Spin indicator={{}} size="large" />;
      </div>
    )
  );
};

export default Spinner;
